import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { ApiEndPoint } from 'src/app/shared/constants/apis.constant'

@Injectable({
	providedIn: 'root',
})
export class RatingService {
	constructor(private http: HttpClient) {}

	getAllRatings(branchId: number, PageNumber: number, PageSize: number) {
		return this.http.get(
			`${ApiEndPoint.GetRatingByBranchIdApi}?BranchId=${branchId}&PageNumber=${PageNumber}&PageSize=${PageSize}`
		)
	}

	hideReview(AppointmentId: number, HideComment: boolean) {
		return this.http.put(
			`${ApiEndPoint.UpdateRatingStatusApi}?AppointmentId=${AppointmentId}&HideComment=${HideComment}`,
			''
		)
	}
}
